import { mapActions } from "vuex";
import ConnectionSuccess from "@/components/ConnectionSuccess";
export default {
  name: "ConnectionSuccessPage",
  components: {
    ConnectionSuccess
  },
  data() {
    return {
      provider: "",
      showAuthStatus: false
    };
  },
  async mounted() {
    var authorization_status = await this.accountAuthorizeRefreshCheck();
    if (!authorization_status || !authorization_status.status) {
      return this.$router.replace("/login"); // stop execution as we had an error
    }
    this.showAuthStatus = true;
  },
  methods: {
    ...mapActions(["accountAuthorizeRefreshCheck"]),
    onClose() {
      this.$router.push("/");
      this.$emit("close-success-window");
    }
  }
};